import classnames from 'classnames';
import React, { Component } from 'react';
//import {CASE_CONFLICT_STATUSES}  from '../../../constants';
import { eapiClient } from '../../../restClient';
import { Translations, convertStringToArrayForOption } from '../../../utils';

export default class CustList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gdocsTerms: this.props.gdocsTerms
    };
  }

  deleteEntity = (e) => {
    const entityId = this.props.passdata;
    const result = window.confirm("Are you sure you want to delete this?");
    if (result) {
      this.props.deleteEntity(entityId);
    }
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);
    return convertedArray;
  }


  getCaseConflictStatus = (expr) => {
    switch (expr) {
      case 'no_conflicts':
        return this.translateWord(this.props.statusOption)[0].split("=")[0] === "no_conflicts" ? this.translateWord(this.props.statusOption)[0].split("=")[1] : ""
      // case "case_in_progress":
      //   return this.translateWord(this.props.statusOption)[1].split("=")[0] === "case_in_progress" ? this.translateWord(this.props.statusOption)[1].split("=")[1] : ""
      case 'Standard':
        return this.translations(this.props.gdocsTerms1)
      case 'New to GDocs':
        return this.translations(this.props.gdocsTerms2)
      case 'Negotiated':
        return this.translations(this.props.gdocsTerms3)
      default:
        return this.translateWord(this.props.statusOption)[0].split("=")[1] || " "
    }
  };

  getCaseNegotaitedStatus(a) {
    if (this.state.gdocsTerms) {
      return this.getCaseConflictStatus(this.props.gdocsTerms ? this.props.gdocsTerms : (this.state.gdocsTerms === 'Negotiated' ? 'Negotiated' : this.state.gdocsTerms))
    } else {
      const entityId = this.props.passdata;
      eapiClient('/cases/' + entityId + '/checkStatus')
        .then(({ data }) => {
          this.setState({ gdocsTerms: data.responseData.gdocsTerms });

          return this.getCaseConflictStatus(data.responseData.gdocsTerms)

        });
    }

  };

  render() {
    let statusIcon = classnames({
      'gdocs-float-left icon icon-circle-error-solid case-in-progress-icon': this.props.conflictStatus !== 'no_conflicts',
      'gdocs-float-left icon icon-circle-confirmation-solid no-conflict-icon': this.props.conflictStatus === 'no_conflicts'
    });
    let gdocsStatusIcon = classnames({
      'gdocs-float-left icon icon-circle-error-solid case-in-progress-icon': this.state.gdocsTerms === 'Negotiated'
    });
    let gdocsTermstext = classnames({
      'gdocs-pright-30': this.state.gdocsTerms !== 'Negotiated'
    });
    return (
      <div className='rightContent gdocs-display-flex gdocs-align-items-center '>
        <span className={`${"case-status gdocs-mt-0"} ${gdocsTermstext}`}>{this.getCaseNegotaitedStatus(this.state.gdocsTerms)}</span>
        {this.state.gdocsTerms === 'Negotiated' ? <div className={gdocsStatusIcon}></div> : ''}
        <div className="separatorBarCust gdocs-float-left gdocs-hide-gdocs-nav-list-actions gdocs-mt-0"></div>
        <span className="case-status gdocs-mt-0">{this.getCaseConflictStatus(this.props.conflictStatus)}</span>
        <div className={`gdocs-ptb0 ${statusIcon}`}></div>
        <div className="separatorBarCust gdocs-float-left gdocs-hide-gdocs-nav-list-actions gdocs-mt-0"></div>
        <div className="icon icon-bin deleteIcon deleteIconCust gdocs-float-left gdocs-hide-gdocs-nav-list-actions gdocs-mt-0 gdocs-ptb0" tabIndex="0" role="button" aria-label="delete" onClick={this.deleteEntity}></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/NavigationList/CustList.js